module.exports = __webpack_public_path__ + "img/diashow (4).a4dcddd.jpg";